module.exports = __webpack_public_path__ + "static/banner_hospital_544@2x-acbd0c026fef67455d82b56e53fbfb52.png";